import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  // Make dashboardAtmCount reactive
  private _dashboardAtmCount = new BehaviorSubject<number>(0);
  public dashboardAtmCount$ = this._dashboardAtmCount.asObservable();

  constructor(public http: HttpClient) {}

  // Getter for current value
  public get dashboardAtmCount(): number {
    return this._dashboardAtmCount.value;
  }

  // Setter to update the value
  public setDashboardAtmCount(count: number) {
    this._dashboardAtmCount.next(count);
  }

  /*
   * list of TILES
   */
  public listAllTilesAPI = (params: any): Observable<any> => {
    return this.http
      .post(environment.baseURL + "/admin-customer-dashboard" + environment.api_postfix, params, {})
      .pipe(
        map((response: any) => {
          const count = Number(response.data.asset_count || 0);
          this.setDashboardAtmCount(count); // update reactive subject
          return response;
        }),
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  };
}
